import React, {memo} from 'react'
import TextField from '@material-ui/core/TextField';
import InputAdornment from "@material-ui/core/InputAdornment";

const AppInputText = memo(
    ({
         id,
         name,
         label,
         value = '',
         required = false,
         block = true,
         onKeyDown = null,
         onBlur = null,
         disabled = false,
         onChange,
         onclick,
         readonly = false,
         icon = null,
         placeholder = '',
     }) => {

        let style = {};

        if (block) {
            style.width = '100%'
        }

        return (
            <TextField
                required={required}
                value={value}
                placeholder={placeholder}
                onChange={onChange}
                onKeyDown={onKeyDown}
                onBlur={onBlur}
                onClick={onclick}
                id={id}
                name={name}
                label={label}
                style={style}
                disabled={disabled}
                InputProps={{
                    readOnly: readonly,
                    startAdornment: icon ? (
                        <InputAdornment position="start">
                            {icon}
                        </InputAdornment>
                    ) : null,
                }}
                variant="outlined"/>
        );

    });
export default AppInputText
